module.exports = __webpack_public_path__ + "images/mdj/members/resume/resume_end_screen/consultant-obata-68b607cabe331dc79c2e870d95075efd.png";